import { CalendarService, ICalendarShift } from '../../services/calendar.service';
import { ShiftService } from '../../services';
import * as moment from 'moment';

class ShiftCalendarController implements ng.IComponentController {

    private shifts: ICalendarShift[];

    private uiConfig: any;
    private eventSources: any = [];

    constructor(
        private ShiftService: ShiftService,
        private CalendarService: CalendarService,
        private $state: ng.ui.IStateService,
        private uiCalendarConfig: any,
        private $scope: ng.IScope,
        private $compile : ng.ICompileService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        // console.log('ShiftCalendarController');

        // var eventSource = {
        //     url: 'http://www.google.com/calendar/feeds/usa__en%40holiday.calendar.google.com/public/basic',
        //     className: 'gcal-event', // an option!
        //     currentTimezone: 'America/Chicago' // an option!
        // };
        this.eventSources = [this.getEvents];

        this.uiConfig = {

            calendar: {

                height: 700,
                locale: 'nl',
                header: {
                    left: 'title',
                    right: ' prev,next month,agendaWeek,agendaDay'
                },
                buttonIcons: {
                    prev: ' fa fa-caret-left',
                    next: ' fa fa-caret-right',
                },
                displayEventEnd: true,

                axisFormat: 'h:mm',

                allDaySlot: false,
                timeFormat: 'H:mm',
                eventLimit: true,
                eventClick: this.openItem,
                //eventDrop: $scope.alertOnDrop,
                //eventResize: $scope.alertOnResize,
                eventRender: this.eventRender
            }
        };

        this.ShiftService.subscribe('ShiftCalendarController', (type) => {
            var newShift;
            var calendarItem;
            switch (type) {
                case 'post': {
                    newShift = this.ShiftService.item;
                    calendarItem = new ICalendarShift();
                    calendarItem.start = newShift.start;
                    calendarItem.end = newShift.end;
                    if (newShift.status) {
                        calendarItem.status = newShift.status.toString();
                    }
                    calendarItem.statusColor = newShift.statusColor;
                    calendarItem.title = newShift.teamLocationName;
                    calendarItem.shift = newShift;
                    this.shifts.push(calendarItem);
                    break;
                }
                case 'put': {
                    
                    newShift = this.ShiftService.item;
                    this.shifts = this.shifts.filter(s => s.shift.id !== newShift.id);
                    if (this.ShiftService.item.status !== 99) {
                        calendarItem = new ICalendarShift();
                        calendarItem.start = newShift.start;
                        calendarItem.end = newShift.end;
                        if (newShift.status) {
                            calendarItem.status = newShift.status.toString();
                        }
                        calendarItem.statusColor = newShift.statusColor;
                        calendarItem.title = newShift.teamLocationName;
                        calendarItem.shift = newShift;
                        this.shifts.push(calendarItem);
                    }
                    break;
                }
                case 'delete': {
                    this.shifts = this.shifts.filter(s => s.shift.id !== this.ShiftService.itemId);
                    break;
                }
            }

            this.uiCalendarConfig.calendars['shiftsCalendar'].fullCalendar('refetchEvents');
        });
    }

    private openItem = (event) => {
        //this.$state.go('shifts.calendar.item', { 'id': event.shift.id });
        this.$state.go('shifts.list.item', { 'id': event.shift.id, 'start' : event.shift.start });
      
    }

    private eventRender = (event, element, view) => {
        element.attr({
            'uib-tooltip': event.title,
            'tooltip-append-to-body': true
        });
        if (moment().isBefore(event.start)) {
            element.css({ 'background-color': event.statusColor, 'border-color': event.statusColor });
        } else {
            element.css({ 'background-color': event.statusColor, 'border-color': event.statusColor, 'opacity': 0.7 });
        }

        this.$compile(element)(this.$scope);
    }

    private getEvents = (start, end, timezone, callback) => {
        this.CalendarService.all({ 'start': start.toDate() , 'end': end.toDate() }).then((events) => {
            this.shifts = events;
            var employeeName;
            this.shifts.forEach(s => {
                employeeName = s.shift.employeeDisplayName || '-';
                s.title = s.title + '\n' + employeeName;
            });
            callback(events);
        });
    }

    public $onDestroy = () => {
        this.ShiftService.unsubscribe('ShiftCalendarController');
    }

}

export const shiftCalendarComponent: ng.IComponentOptions = {
    controller: ShiftCalendarController,
    template: <string>require('./shift.calendar.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.calendar.component.ts